import moment from 'moment'
import { FuzzySearch } from '@/api/purchaseAndSaleAPI'
import { getChargeRecordList } from '@/api/domain/organize'
import selectOptionDict from '@/store/dict/selectOptionDict'


export default function () {
  const oLoading = {
    fuzzy: false,
  }

  // 搜索车牌号
  const getPlateNoData = async (query) => {
    if (query.length >= 4) {
      oLoading.fuzzy = true
      // eslint-disable-next-line no-shadow
      const { code, data } = await FuzzySearch({
        plateNo: query,
        state: 1,
      })
      oLoading.fuzzy = false
      if (code === 1) {
        this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'plateNo', data })
      } else {
        this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'plateNo', data: [] })
      }
    }
  }

  const configData = {
    formData: {
      list: [
        {
          el: 'date-picker',
          itemConfig: {
            label: '操作时间(365天内)',
            prop: 'gmtCreateTime',
          },
          elConfig: {
            type: 'daterange',
            'range-separator': '至',
            'start-placeholder': '开始日期',
            'end-placeholder': '结束日期',
            'picker-options': {
              disabledDate(time) {
                const preYear = moment().subtract(365, 'days').valueOf()
                return time.getTime() > moment('23:59:59', 'hh:mm:ss').valueOf() || time.getTime() < preYear
              },
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '租赁订单ID',
            prop: 'orderId',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
          elConfig: {
            placeholder: '请输入',
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '签约类型',
            prop: 'type',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(selectOptionDict.contractType, true),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '车牌号',
            prop: 'plateNo',
          },
          elConfig: {
            filterable: true,
            remote: true,
            'reserve-keyword': true,
            loading: oLoading.fuzzy,
            placeholder: '请输入',
            'remote-method': (e) => { getPlateNoData(e, 'plateNo') },
            options: {
              label: 'plateNo',
              value: 'plateNo',
              list: [],
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '车辆ID',
            prop: 'carId',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
          elConfig: {
            placeholder: '请输入车辆ID',
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '操作人账号',
            prop: 'userAccount',
          },
          elConfig: {
            placeholder: '请输入操作人账号',
          },
        },
      ],
      exportData: {
        exportTemplate: 'ChargeRecordList',
        filename: '使用明细列表.xlsx',
        permissionName: 'permission_charge_record_list',
      },
      dealWithSearch: (params) => {
        const [gmtCreateFrom = '', gmtCreateTo = ''] = params.gmtCreateTime || []
        const { orgId } = this.$route.query
        return { ...params, gmtCreateFrom, gmtCreateTo, orgId }
      },
    },
    tableData: {
      columns: [
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '操作时间',
          },
        },
        {
          name: 'orgId',
          columnProps: {
            prop: 'orgId',
            label: 'E签宝账号ID',
          },
        },
        {
          name: 'orgName',
          columnProps: {
            width: 300,
            prop: 'orgName',
            label: '企业主体全称',
          },
        },
        {
          name: 'type',
          columnProps: {
            prop: 'type',
            label: '签约类型',
            formatter: (row) => {
              return selectOptionDict.contractType[row.type]
            },
          },
        },
        {
          name: 'orderId',
          columnProps: {
            prop: 'orderId',
            label: '租赁订单ID',
          },
          render: ({ row }) => {
            return this.$createElement('el-link', {
              attrs: {
                target: '__blank',
              },
              props: {
                type: 'primary',
                href: `/workbench/rentOrder/detail?id=${row.orderId}&orderType=personal`,
                underline: false,
              },
            }, row.orderId)
          },
        },
        {
          name: 'carId',
          columnProps: {
            prop: 'carId',
            label: '车辆ID',
          },
          render: ({ row }) => {
            return this.$createElement('el-link', {
              attrs: {
                target: '__blank',
              },
              props: {
                type: 'primary',
                href: `/vehicle/vehicleManage/detail?id=${row.carId}&plateNo=${row.plateNo}`,
                target: '_blank',
                underline: false,
              },
            }, row.carId)
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
          },
          render: ({ row }) => {
            return this.$createElement('el-link', {
              attrs: {
                target: '__blank',
              },
              props: {
                type: 'primary',
                href: `/vehicle/vehicleManage/detail?id=${row.carId}&plateNo=${row.plateNo}`,
                target: '_blank',
                underline: false,
              },
            }, row.plateNo)
          },
        },
        {
          name: 'userName',
          columnProps: {
            prop: 'userName',
            label: '操作人姓名',
          },
        },
        {
          name: 'userAccount',
          columnProps: {
            prop: 'userAccount',
            label: '操作人账号',
          },
        },
      ],
      apiFn: getChargeRecordList,
    },
    isShowDepartment: false,
  }
  return configData
}
